import React from "react";
import classNames from "classnames";

import styles from "./Container.module.scss";

interface Props {
    children: React.ReactNode;
    className?: string;
    contained?: boolean;
    padded?: boolean;
    as?: React.ReactNode | string;
    center?: boolean;
}

const Container = ({
    children,
    className,
    contained = true,
    padded = true,
    as = "div",
    center,
}: Props) => {
    const Wrapper = as as any;
    return (
        <Wrapper
            className={classNames(styles.container, className, {
                [styles["container--padded"]]: padded,
                [styles["container--contained"]]: contained,
                [styles["container--center"]]: center,
            })}
        >
            {children}
        </Wrapper>
    );
};

export default Container;
